<!-- Button to Open Popup -->
<div class="col-lg-2">
  <button type="button" class="btn btn-outline-dark" (click)="openPopup()">Issue Form</button>
</div>

<!-- Backdrop Overlay for Dim Effect -->
<div *ngIf="isPopupVisible" class="overlay"></div>

<!-- Popup Component (Pass closePopup function) -->
<app-supplyform *ngIf="isPopupVisible" [closePopup]="closePopup.bind(this)"></app-supplyform>
<div class="container-fluid">
  <!-- Table Card -->
  <div>
    <div class="row justify-content-center ">
      <div class="col-lg-12 mt-3">
        <div class="card">
          <div class="card-body">
            <!-- Display the table with filled form data -->
            <div class="mt-4">
              <h4>Data Table</h4>
              <!-- <div class="row mt-3">
                <div class="col-md-3">
                  <label for="filterDate" class="form-label">Filter by Date</label>
                  <input type="date" id="filterDate" class="form-control" [(ngModel)]="dateFilter"
                    (change)="applyFilters()" />
                </div>
                <div class="col-md-3">
                  <label for="filterGroup" class="form-label">Filter by Group</label>
                  <select id="filterGroup" class="form-control" [(ngModel)]="groupFilter" (change)="applyFilters()">
                    <option value="">All Groups</option>
                    <option *ngFor="let group of groups" [value]="group.name">{{ group.name }}</option>
                  </select>
                </div>
              </div> -->

              <!-- Table -->
              <!-- <table class="table">
                <thead>
                  <tr>
                    <th>Delivery Date</th>
                    <th>Group</th>
                    <th>Subgroup</th>
                    <th>Material</th>
                    <th>Description</th>
                    <th>Delivery No</th>
                    <th>Bill No</th>
                    <th>Amount1</th>
                    <th>Amount2</th>
                    <th>Location</th>
                    <th class="text-end">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let data of filteredData">
                    <td>{{ data.deliveryDate }}</td>
                    <td>{{ data.group }}</td>
                    <td>{{ data.subgroup }}</td>
                    <td>{{ data.material }}</td>
                    <td>{{ data.description }}</td>
                    <td>{{ data.deliveryNo }}</td>
                    <td>{{ data.billNo }}</td>
                    <td>{{ data.amount1 }}</td>
                    <td>{{ data.amount2 }}</td>
                    <td>{{ data.location }}</td>
                    <td class="text-end">
                      Add action buttons here /edituserList/{{client._id}}
                      <a routerLink="" title="Print" class="mr-2"><i class="feather icon-printer"></i></a>
                      <a routerLink="" title="Go to Inventory" class="mr-2"><i class="feather icon-search"></i></a>
                      <a routerLink="/editMaterialList/{{data._id}}" title="Edit"><i class="feather icon-edit "></i></a>
                    </td>
                  </tr>
                </tbody>
              </table> -->

<!--              
              Pagination
              <div class="pagination-container">
                <div class="pagination mt-3 d-flex justify-content-between align-items-center">
                  Total count and current display count
                  <div>
                    <p>Showing {{currentPage}} - {{ filteredData.length }} of {{ totalCount }}</p>
                  </div>

                  Pagination controls
                  <div class="d-flex">
                    <a class="pagination-btn pt-2" (click)="onPageChange(currentPage - 1)"
                      [ngClass]="{'disabled': currentPage === 1}">
                      <i class="feather icon-chevrons-left"></i>
                    </a>
                    <ng-container *ngFor="let page of getPages()">
                      <a class="pagination-circle" [class.active]="currentPage === page" (click)="onPageChange(page)">
                        {{ page }}
                      </a>
                    </ng-container>
                    <a class="pagination-btn pt-2" (click)="onPageChange(currentPage + 1)"
                      [ngClass]="{'disabled': currentPage === totalPages}">
                      <i class="feather icon-chevrons-right "></i>
                    </a>
                  </div>
                </div>
              </div> -->


            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
